import { useState } from "react";
import { toast } from "sonner";
import { ShieldCheck, Send, Loader2, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const romeTime = (s) => new Date(s).toLocaleString("it-IT", { timeZone: "Europe/Rome", weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
import { Panel } from "@/components/core/AppLayout";
import { ToggleRow } from "@/components/core/NotificationSettings";

const GLOBALS = [
  { k: "riepilogo", title: "Riepilogo mattutino (09:00)", desc: "Invio giornaliero a tutti i soci attivi." },
  { k: "promemoria", title: "Promemoria soci (18:00)", desc: "Digest con appuntamenti e task del giorno dopo." },
  { k: "assegnazione", title: "Avviso assegnazione task", desc: "Email immediata quando una task viene assegnata a un altro socio." },
  { k: "cliente", title: "Promemoria ai clienti (10:00)", desc: "Per gli appuntamenti con «Promemoria al cliente il giorno prima» attivo." },
  { k: "salta_vuoti", title: "Non inviare digest vuoti", desc: "Salta riepilogo e promemoria se non c'è nulla da segnalare." },
  { k: "sollecito", title: "Sollecito approvazioni ai clienti (10:00)", desc: "Ai clienti con portale attivo e post «In revisione» da oltre 3 giorni (max 1 ogni 3 giorni, 3 per post). Disattivabile per singolo cliente." },
  { k: "report_mensile", title: "Report mensili in bozza (1° del mese, 08:00)", desc: "Prepara i PDF del mese precedente in «Report da inviare». Ai clienti non parte nulla senza invio manuale." },
  { k: "report_notifica_soci", title: "Avvisa i soci dei report pronti", desc: "Email ai soci il 1° del mese con il numero di report da controllare." },
  { k: "richieste_sito", title: "Avvisi «Nuove richieste dal sito»", desc: "Email ai soci (che l'hanno attivata) per ogni richiesta dal sito. La copia a info.corefvg@gmail.com e la conferma al mittente partono sempre." },
  { k: "report_salta_inattivi", title: "Salta i clienti senza attività", desc: "Non crea la bozza se nel mese non ci sono post, appuntamenti, task o documenti." },
];

const PreviewButton = ({ tipo, label }) => {
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const r = await api.post("/notifiche/anteprima", { tipo });
      toast.success(`Anteprima inviata a ${r.data.to}`);
    } catch (e) { toast.error(errMsg(e, "Invio anteprima non riuscito")); }
    finally { setBusy(false); }
  };
  return (
    <Button onClick={send} disabled={busy} className="rounded-full bg-[#0A1128] hover:bg-[#E8173A] font-bold" data-testid={`notif-preview-${tipo}`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin mr-1.5" /> : <Send className="h-4 w-4 mr-1.5" />}{label}
    </Button>
  );
};

export const AdminNotifications = ({ globali, jobs, onChange }) => {
  const [saving, setSaving] = useState(false);
  const toggle = async (k, v) => {
    setSaving(true);
    try {
      const r = await api.put("/notifiche/globali", { ...globali, [k]: v });
      onChange(r.data.globali);
      toast.success("Impostazioni aggiornate");
    } catch (e) { toast.error(errMsg(e)); }
    finally { setSaving(false); }
  };
  return (
    <Panel className="p-8 core-rise core-delay-2" data-testid="admin-notifications-panel">
      <h3 className="font-display text-xl font-extrabold text-[#0A1128] flex items-center gap-2 mb-1"><ShieldCheck className="h-5 w-5 text-[#E8173A]" />Amministrazione email</h3>
      <p className="text-sm text-slate-600 mb-2">Interruttori globali: valgono per tutti i soci.</p>
      {GLOBALS.map((g) => <ToggleRow key={g.k} {...g} checked={!!globali[g.k]} onChange={(v) => toggle(g.k, v)} disabled={saving} testid={`notif-global-${g.k}`} />)}
      <div className="mt-6 text-xs font-bold uppercase tracking-wider text-slate-600 mb-2">Invia ora un'anteprima a me</div>
      <div className="flex flex-wrap gap-2">
        <PreviewButton tipo="riepilogo" label="Anteprima riepilogo" />
        <PreviewButton tipo="promemoria" label="Anteprima promemoria" />
      </div>
      <div className="mt-6 text-xs font-bold uppercase tracking-wider text-slate-600 mb-2">Pianificazione (Europe/Rome)</div>
      <div className="space-y-1.5" data-testid="notif-jobs">
        {jobs.map((j) => (
          <div key={j.id} className="flex items-center gap-2 text-sm text-[#0A1128]" data-testid={`notif-job-${j.id}`}>
            <Clock className="h-4 w-4 text-[#E8173A]" /><span className="font-bold w-12">{j.orario}</span>{j.label}
            <span className="text-slate-600">· prossima: {j.prossima_esecuzione ? romeTime(j.prossima_esecuzione) : "—"}</span>
          </div>
        ))}
      </div>
    </Panel>
  );
};
